import React from "react";
import { useHistory } from "react-router-dom";

import { Row, Col } from "antd";
import Layout from "../../components/Layout";
import { Phone } from "../../assets/images/icons/customIcon";

const Index = () => {
  const route = useHistory();

  return (
    <Layout>
      <div className="banner">
        <img
          style={{ maxWidth: 300, width: "100%" }}
          src={require("../../assets/images/SS1.png")}
          alt=""
        />
      </div>
      <div className="body">
        <div className="menu">
          <Row gutter={[20, 20]}>
            <Col flex="1">
              <div className="btn" onClick={() => route.push("/search")}>
                <div>
                  <img
                    width="80"
                    src={require("../../assets/images/icon_main_un.ae8c2924.png")}
                    alt=""
                  />
                </div>
                <div className="label">
                  ค้นหาด้วยชื่อ <br /> หรือ UN No.
                </div>
              </div>
            </Col>
            <Col flex="1">
              <div className="btn" onClick={() => route.push("/photo")}>
                <div>
                  <img
                    width="80"
                    src={require("../../assets/images/icon_main_img.dc74bde9.png")}
                    alt=""
                  />
                </div>
                <div className="label">
                  ค้นหาด้วย <br /> รูปภาพ
                </div>
              </div>
            </Col>
            <Col flex="1">
              <div className="btn" onClick={() => route.push("/category")}>
                <div>
                  <img
                    width="80"
                    src={require("../../assets/images/icon_main_guide.7fd4b96d.png")}
                    alt=""
                  />
                </div>
                <div className="label" style={{ marginTop: 25 }}>
                  ค้นหาตาม <br />
                  หมวดคำแนะนำ
                </div>
              </div>
            </Col>
            <Col flex="1">
              <div className="btn" onClick={() => route.push("/document")}>
                <div>
                  <img
                    width="80"
                    src={require("../../assets/images/report.png")}
                    alt=""
                  />
                </div>
                <div className="label">
                  ข้อมูล <br /> อ้างอิง
                </div>
              </div>
            </Col>
            <Col flex="1">
              <div className="btn" onClick={() => route.push("/chemical")}>
                <div>
                  <img
                    width="120"
                    src={require("../../assets/images/icon_chemical.png")}
                    alt=""
                  />
                </div>
                <div className="label">
                  ค่าป้องกัน <br /> สารเคมี
                </div>
              </div>
            </Col>
            <Col span={24}>
              <div className="btn-call" onClick={() => route.push("/call")}>
                <Phone fill="#fff" height={40} />
                <span style={{ marginLeft: 10 }}>เบอร์โทรศัพท์ฉุกเฉิน</span>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
};

export default Index;
